// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"_1sTubtxrqYc_C9dth28PgQ","square":"_1HHfGlgoA7d6G8a1cwIMaF","video":"_1EBCXFyGqtYE_Ff26VYDGG","overlay":"CcDPdvyGzS6miKle3Yb4v","triangle":"s-MR_7-MiDlM_jeKlKsod"};